import React from 'react';
import { MainLayout } from '@components';
import ECGComponents from './ECG';

export default function ECGPage(props) {
  return <MainLayout footer="main" children={<ECGComponents {...props} />} />;
}
